import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { base64Decoding, base64Encoding, getTimestampToDate } from "../../../common/util";
import { SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { POPUP_TYPE } from "../../../value/type";


import { DetailProps } from "../../../interfaceTypes/ContentsProps";
import { useTranslation } from "react-i18next";
import { PopupModalItemType } from "../../base/modal/PopupModal";
import { tableHeaders } from "./StorageData";
import StorageDetailView from "./StorageDetailView";
import { StorageDetailData, initStorageDetailData } from "./StorageDetailData";




export default function StorageDetailContainer(props:DetailProps) {
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);
    const [targetId, setTargetId] = useState(props.targetId || '');
    const [refreshYn, setRefreshYn] = useState(false);
    const [selectItems, setSelectItems] = useState([]);
    const [detailData, setDetailData] = useState<StorageDetailData>(initStorageDetailData);
    const [actionResultTitle, setActionResultTitle] = useState("");
    const [actionResultMessage, setActionResultMessage] = useState("");
    const [actionResults, setActionResults] = useState<PopupModalItemType[]>([]);
    const [actionResultCount, setActionResultCount] = useState(0);
    const fetchIdRef = useRef(0);
    const headers = useMemo(() => tableHeaders, []);
    const navigate = useNavigate();


    useEffect(() => {
        props.setLoading(false);
        AlertFunction('');
    }, []);


    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    useEffect(() => {
        if(targetId) {
            executeLoadStoragePools();
        }
    }, [targetId]);


    useEffect(() => {
        if(targetId && refreshYn) {
            executeLoadStoragePools();
        }
    }, [refreshYn]);



    useEffect(() => {
        if(!targetId) {
            const localTargetId = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.STORAGE_POOL_DETAIL_ID));
            if(localTargetId) {
                setTargetId(localTargetId);
            } else {
                navigate(`${PAGE_URL.ERRORPAGE}`);
            }
        } else {
            sessionStorage.setItem(SESSIONSTORAGE.STORAGE_POOL_DETAIL_ID, base64Encoding(targetId));
        }
    }, [props]);



    function executeLoadStoragePools() {
        props.setLoading(true);
        requests.get(PLATFORM_URL.STORAGE_POOL + "/" + targetId)
        .then((response) => {
            if (response.status === 200 && response.data) {
                setDetailData(response.data);
            }
            props.setLoading(false);
            setRefreshYn(false);
        })
        .catch(() => {
            props.setLoading(false);
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            setRefreshYn(false);
        });
    }




    const fetchData = useCallback(({ pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search }) => {
        const fetchId = ++fetchIdRef.current;
        if(fetchId === fetchIdRef.current) {
        }
    }, []);


    return (
        <StorageDetailView
            detailData={detailData}
            infoText={infoText}
            infoError={infoError}
            fetchData={fetchData}
            headers={headers}
            refreshYn={refreshYn}
        />
    );
}
